export default {
  BaseUrl: `/api/`,
  gapiConfig: {
    apiKey: 'AIzaSyD6lhXi0m-NctANgBUQnm5bjJo9Cg6t-3U',
    clientId:
      '845319349417-cfe7l2fr5m4t7jg23fed5vp4nskaqdil.apps.googleusercontent.com',
    fetch_basic_profile: true,
    scope: 'email profile',
    // see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
  },
  identityUrl: `https://identitysts-gcp.wyo.gov/api`,
  // identityUrl: `http://localhost:5000/api`,
}
